import {createApp} from '@/app'
import pageRouter from './router'

const {app, router} = createApp('index', pageRouter)

router.onReady(() => app.$mount('#app'))



// WEBPACK FOOTER //
// ./src/pages/ocean/entry.js